import { apiFetch, setToken, clearToken } from "./client";

// Logs in and stores the JWT. Returns the user object from /me.
export const login = async (email, password) => {
  const { access_token } = await apiFetch("/api/auth/login", {
    method: "POST",
    auth: false,
    form: { username: email, password },
  });
  setToken(access_token);
  return me();
};

// Backend returns { id, email, full_name, role: "Professeur"|"Etudiant", is_admin }.
export const me = () => apiFetch("/api/auth/me");

export const logout = () => {
  clearToken();
  return apiFetch("/api/auth/logout", { method: "POST", auth: false }).catch(() => null);
};
